import { z } from "zod";
import {
  OpenInvitationIdPublicSchema,
  EventIdPublicSchema,
  MagicLinkIdPublicSchema,
} from "./branded-id.schemas.js";
import { OpenInvitationStatusSchema } from "./open-invitation-state.schemas.js";
import { statusHistoryEntrySchema } from "./status-history.schemas.js";
import { LocaleCodeSchema, LocaleCode } from "./locale.schemas.js";

const _openInvitationStatusHistoryEntrySchema = statusHistoryEntrySchema(
  OpenInvitationStatusSchema,
);

const _openInvitationCreatableSchema = z.object({
  phrase: z.string(),
  label: z.string().nullable().optional(),
  maxParticipants: z.number().int().positive().nullable().optional(),
  expiresAt: z.coerce.date().nullable().optional(),
});

const _openInvitationSchema = _openInvitationCreatableSchema.extend({
  label: z.string().nullable(),
  maxParticipants: z.number().nullable(),
  expiresAt: z.coerce.date().nullable(),
  isDefault: z.boolean().default(false),
  lang: LocaleCodeSchema.default(LocaleCode.NOT_SET),
  idPublic: OpenInvitationIdPublicSchema,
  eventIdPublic: EventIdPublicSchema,
  magicLinkIdsPublic: z.array(MagicLinkIdPublicSchema).readonly(),
  status: OpenInvitationStatusSchema,
  joinCount: z.number(),
  interactionCount: z.number(),
  statusHistory: z.array(_openInvitationStatusHistoryEntrySchema).readonly(),
  lastJoinedAt: z.coerce.date().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export const OpenInvitationSchema = _openInvitationSchema.readonly();
export type OpenInvitation = z.infer<typeof OpenInvitationSchema>;

// Event-owner-facing redemption surface matches the public read shape (no internal IDs,
// phraseNormalized or metadata). Separate endpoints/view per PLA-871 decision 2.
export const OpenInvitationEventOwnerViewSchema = OpenInvitationSchema;
export type OpenInvitationEventOwnerView = OpenInvitation;
